import ReactDOM from 'react-dom'
import * as PropTypes from 'prop-types'
import classNames from 'classnames'
import KeyHandler, { KEYPRESS } from 'react-key-handler'

import toFullscreenAnimationStyles from './ToFullscreenAnimation.css'
import { KEYCODES } from '/javascripts/constants/keyCodes'

import {
  ButtonWithIcon,
  IconClose,
  ScrollLock
} from '/react/library/'

import { ToFullscreenAnimationZoom } from './ToFullscreenAnimationZoom'

export class ToFullscreenAnimation extends React.PureComponent {
  static propTypes = {
    animationFrameTarget: PropTypes.any.isRequired,
    closeFullscreenCallback: PropTypes.func.isRequired,
    content: PropTypes.node.isRequired,
    fadeContentIn: PropTypes.bool,
    onAnimationEnd: PropTypes.func,
    onAnimationStart: PropTypes.func,
    uiElements: PropTypes.node,
    zoomContent: PropTypes.node
  }

  state = {
    isToFullscreenAnimationDone: false
  }

  rootElement = null

  handleToFullscreenAnimationEnd = () => {
    const onAnimationEndCallback = this.props.onAnimationEnd

    this.setState({ isToFullscreenAnimationDone: true }, () => {
      if (onAnimationEndCallback) onAnimationEndCallback()
    })
  }

  createRootElement = () => {
    this.rootElement = document.createElement('div')
    document.body.appendChild(this.rootElement)
  }

  destroyRootElement = () => {
    document.body.removeChild(this.rootElement);
    this.rootElement = null
  }

  componentDidMount () {
    const onAnimationStartCallback = this.props.onAnimationStart

    if (onAnimationStartCallback) onAnimationStartCallback()
  }

  componentWillUnmount () {
    if (this.rootElement) this.destroyRootElement()
  }

  render () {
    const {
      animationFrameTarget,
      closeFullscreenCallback,
      content,
      fadeContentIn,
      uiElements,
      zoomContent
    } = this.props

    const {
      isToFullscreenAnimationDone
    } = this.state

    if (!this.rootElement) this.createRootElement()

    const childProps = {
      animationFrameTarget,
      closeFullscreenCallback,
      fadeContentIn,
      handleToFullscreenAnimationEnd: this.handleToFullscreenAnimationEnd,
      isToFullscreenAnimationDone
    }

    return ReactDOM.createPortal(
      (
        <div className={classNames(
          toFullscreenAnimationStyles.fixedOverlayContainer,
          { [toFullscreenAnimationStyles.fixedOverlayContainerHasBackground]: isToFullscreenAnimationDone }
        )}>
          <ToFullscreenAnimationContent {...childProps} children={content} />
          <ToFullscreenAnimationZoom {...childProps} children={zoomContent} />
          <ToFullscreenAnimationUi {...childProps} children={uiElements} />
          <ScrollLock />
          {isToFullscreenAnimationDone && (
            <KeyHandler
              keyEventname={KEYPRESS}
              code={KEYCODES.ESC}
              onKeyHandle={closeFullscreenCallback}
            />
          )}
        </div>
      ),
      this.rootElement
    )
  }
}

export const ToFullscreenAnimationContent = (props) => (
  <div className={classNames(
    toFullscreenAnimationStyles.content,
    {
      [toFullscreenAnimationStyles.contentIsVisible]: props.isToFullscreenAnimationDone,
      [toFullscreenAnimationStyles.contentHasFadeIn]: props.fadeContentIn
    }
  )}>
    <div>
      {props.children}
    </div>
  </div>
)

export const ToFullscreenAnimationUi = (props) => (
  <div className={classNames(
    toFullscreenAnimationStyles.ui,
    { [toFullscreenAnimationStyles.uiIsVisible]: props.isToFullscreenAnimationDone }
  )}>
    {props.children}
    <div className={toFullscreenAnimationStyles.closeButton}>
      <ButtonWithIcon isLight onClick={props.closeFullscreenCallback}>
        <IconClose isLight />
      </ButtonWithIcon>
    </div>
  </div>
)
